import { CartItem, Spinner } from "dab-component-lib";
import React from "react";
import { graphql } from "react-apollo";
import { productByCode } from "../../queries";
import { LoadingStyle } from "../../utils/style-utils";

class oldOrderDetailProduct extends React.Component {
  render() {
    const { productByCode, product, editable = true } = this.props;
    let photoUrl = "";

    if (
      !productByCode.loading &&
      !productByCode.error &&
      productByCode.productcodeGraphql1View.results.length > 0
    ) {
      photoUrl =
        productByCode.productcodeGraphql1View.results[0].fieldProductImages
          .length > 0 &&
        productByCode.productcodeGraphql1View.results[0].fieldProductImages[0]
          .url;
    }

    if (productByCode.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }

    return (
      <div>
        {!productByCode.loading && !productByCode.error && (
          <CartItem
            currency={product.currency}
            editable={editable}
            requiredNotes={false}
            lang={
              localStorage.getItem("language")
                ? localStorage.getItem("language")
                : "it"
            }
            name={product.item_description}
            notesReadOnly={true}
            note={product.line_item_note || ""}
            photoUrl={photoUrl}
            price={product.amount}
            productId={product.item}
            quantity={product.quantity}
            size={product.size}
            showNotes={true}
          />
        )}
      </div>
    );
  }
}

export default graphql(productByCode, {
  name: "productByCode",
  options: (props) => ({
    variables: {
      code: props.product.item,
    },
  }),
})(oldOrderDetailProduct);



// WEBPACK FOOTER //
// ./src/components/oldOrderDetailProduct/index.js